/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
export default {
    GetAllGroupsForDropDown,
    GetVCCFactoriesByGroupID,
    GetSupplierPaymentAuditReport
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetSupplierPaymentAuditReport(model) {
    const response = await CommonPost('/api/SupplierPaymentAuditReport/GetSupplierPaymentAuditReport', null, model);
    return response.data;
}

